import React from 'react';
import GreetingCard2023 from 'views/GreetingCard2023';

const AccountGeneralPage = () => {
  return <GreetingCard2023/>;
};

export default AccountGeneralPage;

// EnvironmentDay2023